<template>
  <v-container fluid px-3 py-0>
    <v-card class="screener" flat outlined tile>
      <v-row no-gutters>
        <v-col sm="3" class="d-none d-sm-flex">
          <ogs
            :ogs.sync="req.ogs"
            :selectedFilters="selectedFilters"
            @applyFilter="apply"
            @toggleFilter="toggleFilter"
            @save="saveFilter"
            :name="screener.name"
            :description="screener.description"
            :custom="screener.custom"
            :reload="reload"
          ></ogs>
        </v-col>
        <v-col cols="12" sm="9">
          <records
            :records="records"
            :headers="req.options.fields"
            @paginate="viewMore"
            :showViewMore="showViewMore"
            :limit="limit"
            :totalCount="totalCount"
            :loading="loading"
            @sort="invokeSort"
            @exportFn="exportFn"
          ></records>
        </v-col>
      </v-row>
    </v-card>
    <v-bottom-navigation
      app
      color="primary"
      class="d-flex d-sm-none btm-nav shadow"
      fixed
      grow
    >
      <!-- <v-btn>
        <span>New Screen</span>
        <v-icon>mdi-clipboard-file-outline</v-icon>
      </v-btn> -->
      <v-bottom-sheet scrollable>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on">
            All Screens
            <v-icon>mdi-file-document-outline</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="pa-0">
            <v-tabs-items v-model="tab">
              <v-tab-item> <AllScreens no-heading /> </v-tab-item>
              <v-tab-item>
                <SavedScreens :open="`${tab === 1}`" />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="pa-0">
            <v-tabs v-model="tab" grow>
              <v-tabs-slider></v-tabs-slider>
              <v-tab> Premium Screeners </v-tab>
              <v-tab> Saved Screeners </v-tab>
            </v-tabs>
          </v-card-title>
        </v-card>
      </v-bottom-sheet>
      <v-btn @click="exportFn()">
        <span>Export</span>
        <v-icon>mdi-file-download-outline</v-icon>
      </v-btn>
      <v-bottom-sheet v-model="mobileSideBar">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on">
            <span>Filter</span>
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <v-card>
          <ogs
            :ogs.sync="req.ogs"
            :selectedFilters="selectedFilters"
            @applyFilter="apply"
            @toggleFilter="toggleFilter"
            @closeFilter="closeFilter"
            @save="saveFilter"
            :name="screener.name"
            :description="screener.description"
            :custom="screener.custom"
            :reload="reload"
          ></ogs>
        </v-card>
      </v-bottom-sheet>
    </v-bottom-navigation>
  </v-container>
</template>

<style>
.screener {
  /* 50px -header, 0px -padding */
  height: calc(100vh - 50px - 5px);
  overflow: hidden;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2) !important;
}
.shadow {
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1) !important;
}
.btm-nav.theme--light.v-bottom-navigation
  .v-btn:not(.v-btn--active):not(.v-btn--disabled) {
  color: var(--v-primary-base) !important;
}
.s-header {
  height: 70px;
}
.header-color {
  background-color: #f5f5f559;
}
.v-input__append-inner {
  margin-top: 5px !important;
}
</style>

<script>
import ogs from "@/components/filter/Filter.vue";
import Records from "@/components/report/Records.vue";
import AllScreens from "@/components/report/AllScreens.vue";
import SavedScreens from "@/components/report/SavedScreens.vue";

export default {
  name: "Screener",
  components: { ogs, Records, AllScreens, SavedScreens },
  props: {
    slug: { type: String, default: "BASIC" },
  },
  data: () => ({
    // match: {},
    records: [],
    selectedFilters: [],
    totalCount: 0,
    limit: 0,
    loading: false,
    mobileSideBar: false,
    req: { ogs: [], options: { fields: [] } },
    tab: 0,
    reload: false,
  }),
  methods: {
    closeFilter() {
      this.mobileSideBar = false;
    },
    setScreener(res) {
      this.$store.commit("setScreener", {
        slug: res.slug,
        name: res.name,
        description: res.description,
        custom: res.custom,
      });
    },
    setReport(res) {
      this.loading = false;
      this.req = res.body.req;
      this.records = res.body.data;
      this.totalCount = res.body.count;
      this.selectedFilters = this.req.options.components;
      this.limit = this.records.length;
      this.setScreener(this.req);
      this.reload = true;
    },
    get() {
      // this.$root.$loader.start(`Loading '${this.screener.name}' screener`);
      this.loading = true;
      this.reload = false;
      let url = `/screener/${this.slug}`;
      if (this.screener.custom) {
        url = `/customScreeners/${this.slug}`;
      }
      url = `${url}?sId=${this.$store.getters.getSessionId}`;
      this.$http.get(url).then((res) => {
        this.setReport(res);
      });
      // .finally(() => {
      //   this.$root.$loader.stop();
      // });
    },
    applyFilter() {
      this.loading = true;
      this.reload = false;
      let url = `/screener/${this.req.slug}/applyFilters?sId=${this.req.sId}`;
      this.$http.put(url, this.req).then((res) => {
        this.setReport(res);
      });
    },
    viewMore() {
      this.loading = true;
      let url = `/screener/${this.req.slug}/paginate`;
      url = `${url}?sId=${this.req.sId}&start=${this.limit}&limit=${this.req.options.limitPerPage}`;
      this.$http.get(url).then((res) => {
        this.loading = false;
        this.records = [...this.records, ...res.body];
        this.limit = this.records.length;
      });
    },
    invokeSort({ sortKey, sortOrder }) {
      this.loading = true;
      let url = `/screener/${this.req.slug}/sortBy`;
      url = `${url}?sId=${this.req.sId}&sort_by=${sortKey}&sort_order=${sortOrder}`;
      this.$http.get(url).then((res) => {
        this.loading = false;
        this.req.options.sortKey = sortKey;
        this.req.options.sortOrder = sortOrder;
        this.records = res.body;
        this.limit = this.records.length;
      });
    },
    toggleFilter({ id, lock }) {
      if (lock) {
        this.$root.$subscribe.open();
        return;
      }
      let action;
      const idx = this.req.options.components.indexOf(id);
      if (idx > -1) {
        action = "remove";
        this.req.options.components.splice(idx, 1);
      } else {
        action = "add";
        this.req.options.components.push(id);
      }
      this.loading = true;
      this.reload = false;
      let url = `/screener/${this.slug}/toggleFilters`;
      let req = {
        action: action,
        filterId: id,
        screen: this.req,
      };
      this.$http.put(url, req).then((res) => {
        this.setReport(res);
      });
    },
    apply({ action, cbId }) {
      switch (action) {
        /*case "add":
          if (!this.match[id]) {
            this.match[id] = [val];
          } else {
            this.match[id].push(val);
          }
          break;
        case "remove": {
          let i = this.match[id].indexOf(val);
          if (i > -1) {
            this.match[id].splice(i, 1);
          }
          if (!this.match[id].length) {
            delete this.match[id];
          }
          break;
        }
        case "clear_og":
          delete this.match[id];
          break;*/
        case "reset": {
          // this.match = {};
          this.get();
          return;
        }
        case "refresh": {
          // @todo: verify
          let req = JSON.parse(JSON.stringify(this.req));
          let showMsg = false;
          req.ogs.forEach((og) => {
            if (og.refId === "STOCK_UNIVERSE") {
              return;
            }
            switch (og.optionType) {
              case "Checkbox":
                og.checkboxes.forEach((cb) => {
                  if (cb.selected) {
                    showMsg = true;
                  }
                  cb.selected = false;
                });
                break;
              case "Slider":
                if (og.slider.selected) {
                  showMsg = true;
                }
                og.slider.selected = false;
                og.slider.selectedMin = og.slider.options.floor;
                og.slider.selectedMax = og.slider.options.ceil;
                break;
            }
          });
          if (showMsg) {
            this.$root.$confirm
              .open(
                "Confirm",
                "This action will reset all your filters. Do you want to continue?",
                {
                  info: false,
                }
              )
              .then((confirm) => {
                if (confirm) {
                  this.req = req;
                  this.applyFilter();
                  return;
                }
                // revert back the selcetion
                this.req.ogs.some((og) => {
                  if (og.refId === "STOCK_UNIVERSE") {
                    og.checkboxes.some((cb) => {
                      if (cb.refId === cbId) {
                        cb.selected = !cb.selected;
                        return true;
                      }
                    });
                    return true;
                  }
                });
              });
            return;
          }
        }
      }
      this.applyFilter();
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "screener_report.csv"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    exportFn() {
      if (!this.$store.getters.isExportAllowed) {
        this.$root.$subscribe.open();
        return;
      }
      let url = `/screener/${this.slug}/download?sId=${this.req.sId}`;
      this.$http
        .put(url, this.req.options.fields, { responseType: "arraybuffer" })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    },
    saveFilter({ name, description }) {
      this.$root.$loader.start();
      let req = JSON.parse(JSON.stringify(this.req));
      req.name = name;
      req.description = description;
      this.$http
        .post("/customScreeners", req)
        .then((res) => {
          this.loading = false;
          this.$store.dispatch("fetchCustomScreeners");
          this.$store.commit("setScreener", {
            slug: res.body.slug,
            name: name,
            description: description,
            custom: true,
          });
        })
        .catch((e) => {
          alert(e.body.message);
        })
        .finally(() => {
          this.$root.$loader.stop();
        });
    },
  },
  computed: {
    showViewMore() {
      return this.totalCount > this.limit;
    },
    screener() {
      return this.$store.getters.screener;
    },
  },
  created() {
    this.get();
  },
};
</script>
